import { Injectable } from '@angular/core';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class IdentityService {
  private authenticated:(value: firebase.User)=>void
  private authenticationFailed:(reason: any)=>void

  private userPromise: Promise<firebase.User>;
  constructor() {
    const _this = this;
    this.userPromise = new Promise<firebase.User>(function(resolve, reject){
      console.log("initalizing promise");
      _this.authenticated = resolve;
      _this.authenticationFailed = reject;
    });
    this.userPromise.then((user)=>{
      console.log(user);
    });
    firebase.auth().onAuthStateChanged(async (user)=>{
      if (user){
        await user.getIdToken(true);
        this.authenticated(user);
      } else this.authenticationFailed("No user");
    }, (error)=>{
      this.authenticationFailed(error);
    });

  }

  async getIdentity(): Promise<firebase.User>{
    return this.userPromise;
  }
}
